import type { IServiceContext } from './IServiceContext.js';

export abstract class OAuthTokenProvider {
    public abstract getToken(context: IServiceContext): Promise<string>;
}

class NullOAuthTokenProvider extends OAuthTokenProvider {
    public getToken(context: IServiceContext): Promise<string> {
        return Promise.resolve('');
    }

}

export const NullAuthTokenProvider = new NullOAuthTokenProvider();
export const OAUTH_TOKEN_PROVIDER = Symbol.for('OAuthTokenProvider');